"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchField = exports.CreatableSelectField = exports.CompensationField = exports.CompensationCurrencySelector = exports.SelectField = exports.MaskedInputField = exports.CurrencyInputField = exports.HiddenField = exports.TextareaField = exports.DatePickerField = exports.InputField = exports.FieldWrapper = exports.FieldMessage = exports.FormCentered = void 0;

var _react = _interopRequireWildcard(require("react"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _polished = require("polished");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _currencySelectorChevron = _interopRequireDefault(require("../../../../public/images/icons/currency-selector-chevron.svg"));

var _Compensation = require("../Compensation");

var _CurrencySelector = require("./CurrencySelector");

var _Input = require("./Input");

var _Select = require("../Select");

var _helpers = require("../../../domains/countries/helpers");

var _InputPassword = _interopRequireDefault(require("../../../domains/registration/auth/InputPassword"));

var _Form = require("../../../domains/registration/onboarding/shared/styles/Form");

var _forms = require("../../../helpers/forms");

var _validationSchema = require("../../../helpers/validationSchema");

var _motion = require("../../../style/motion");

var _CurrencyInput = _interopRequireDefault(require("./CurrencyInput"));

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FormCentered = _styledComponents["default"].form.withConfig({
  displayName: "Form__FormCentered",
  componentId: "sc-1my8gp1-0"
})(["max-width:600px;margin:0 auto;"]);

exports.FormCentered = FormCentered;

var FieldMessage = _styledComponents["default"].p.withConfig({
  displayName: "Form__FieldMessage",
  componentId: "sc-1my8gp1-1"
})(["", ";margin:0 auto;text-align:center;max-width:510px;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.typography.body;
}, function (_ref2) {
  var theme = _ref2.theme;

  switch (theme.mode) {
    case 'light':
      return (0, _styledComponents.css)(["color:var(--colors-blank);"]);

    case 'dark':
    default:
      return (0, _styledComponents.css)(["color:var(--colors-bayoux);"]);
  }
});

exports.FieldMessage = FieldMessage;

var FieldWrapper = function FieldWrapper(_ref3) {
  var name = _ref3.name,
      label = _ref3.label,
      type = _ref3.type,
      as = _ref3.as,
      description = _ref3.description,
      displayLabel = _ref3.displayLabel,
      preventJump = _ref3.preventJump,
      error = _ref3.error,
      touched = _ref3.touched,
      children = _ref3.children;
  var displayErrorComponent = !description || error && touched;
  var isRadio = type === 'radio';
  var Hint = displayErrorComponent ? __jsx(_Form.FormFieldError, {
    preventJump: preventJump,
    name: name,
    description: description
  }) : __jsx(_Input.LabelText, null, description);
  return __jsx(_Input.InputLabel, {
    as: as
  }, __jsx(_Input.TopLabel, {
    show: displayLabel,
    $size: isRadio && 'md'
  }, label), isRadio && Hint, children, !isRadio && Hint);
};
/**
 * getInputForType
 *
 * Returns the relevant component for a given input type
 *
 * @param {String} type - The input type
 */


exports.FieldWrapper = FieldWrapper;

function getInputForType(type) {
  switch (type) {
    case 'password':
      return _InputPassword["default"];

    default:
      return _Input.Input;
  }
}
/**
 * InputField
 *
 * Formik input field abstraction, containing label, description and field error
 *
 * @param {Object} props - Component props
 * @param {String} props.name - Form field name
 * @param {String} props.type - Form field <input /> type
 * @param {String} props.label - Field label
 * @param {String} props.description - Field description
 * @param {String} props.size - Size key as provided by Theme
 */


var InputField = function InputField(_ref4) {
  var name = _ref4.name,
      type = _ref4.type,
      placeholder = _ref4.placeholder,
      label = _ref4.label,
      description = _ref4.description,
      autoComplete = _ref4.autoComplete,
      autoFocus = _ref4.autoFocus,
      size = _ref4.size,
      preventJump = _ref4.preventJump,
      displayLabel = _ref4.displayLabel,
      dataTestid = _ref4['data-testid'],
      onChange = _ref4.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["name", "type", "placeholder", "label", "description", "autoComplete", "autoFocus", "size", "preventJump", "displayLabel", "data-testid", "onChange"]);

  var _useFormikContext = (0, _formik.useFormikContext)(),
      values = _useFormikContext.values,
      setValues = _useFormikContext.setValues; // The "children" approach was chosen because it returns
  // the "meta" prop which contains "error" and "touched" relative to the current field
  // instead of having to fetch from "errors" as provided if using "component"


  var InputComponent = getInputForType(type);
  /**
   * Call custom onChange handler
   * @param {object} e event object
   * @param {object} field input object from formik
   */

  function handleOnChange(e, nativeOnChange) {
    if (onChange) onChange(e, values, setValues);
    nativeOnChange(e);
  }

  var typeAttrs = type === 'number' ? _forms.inputModeAttrs : {
    type: type
  };
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref5) {
    var _field$value;

    var field = _ref5.field,
        _ref5$meta = _ref5.meta,
        error = _ref5$meta.error,
        touched = _ref5$meta.touched;
    return __jsx(FieldWrapper, {
      name: name,
      label: label,
      description: description,
      displayLabel: displayLabel || ((_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.toString().length),
      error: error,
      touched: touched,
      preventJump: preventJump
    }, __jsx(InputComponent, (0, _extends2["default"])({}, field, {
      value: field.value
    }, typeAttrs, {
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      "data-testid": dataTestid,
      placeholder: placeholder || label,
      className: error && touched ? 'error' : '',
      size: size,
      onChange: function onChange(e) {
        return handleOnChange(e, field.onChange);
      }
    }, props)));
  });
};

exports.InputField = InputField;

var DatePickerField = function DatePickerField(_ref6) {
  var dataTestid = _ref6['data-testid'],
      autoComplete = _ref6.autoComplete,
      autoFocus = _ref6.autoFocus,
      description = _ref6.description,
      displayLabel = _ref6.displayLabel,
      label = _ref6.label,
      name = _ref6.name,
      onChange = _ref6.onChange,
      placeholder = _ref6.placeholder,
      preventJump = _ref6.preventJump,
      size = _ref6.size,
      type = _ref6.type,
      props = (0, _objectWithoutProperties2["default"])(_ref6, ["data-testid", "autoComplete", "autoFocus", "description", "displayLabel", "label", "name", "onChange", "placeholder", "preventJump", "size", "type"]);

  var _useFormikContext2 = (0, _formik.useFormikContext)(),
      setFieldValue = _useFormikContext2.setFieldValue;

  return __jsx(_formik.Field, {
    name: name
  }, function (_ref7) {
    var _ref7$field = _ref7.field,
        value = _ref7$field.value,
        fieldOnChange = _ref7$field.onChange,
        field = (0, _objectWithoutProperties2["default"])(_ref7$field, ["value", "onChange"]),
        _ref7$meta = _ref7.meta,
        error = _ref7$meta.error,
        touched = _ref7$meta.touched;

    var handleChange = function handleChange(date) {
      setFieldValue(field.name, date);
      if (fieldOnChange) fieldOnChange(date);
    };

    return __jsx(FieldWrapper, {
      description: description,
      displayLabel: true,
      error: error,
      label: label,
      name: name,
      preventJump: preventJump,
      touched: touched
    }, __jsx(_DatePicker["default"], (0, _extends2["default"])({
      autocomplete: "off" // Prevents it from appearing on top of the custom datepicker

    }, field, props, {
      autoFocus: autoFocus,
      className: error && touched ? 'error' : '',
      placeholderText: placeholder,
      "data-testid": dataTestid,
      onChange: handleChange,
      selected: value && new Date(value) || null,
      size: size
    })));
  });
};

exports.DatePickerField = DatePickerField;

var TextareaField = function TextareaField(props) {
  return __jsx(InputField, (0, _extends2["default"])({}, props, {
    as: _Input.Textarea,
    displayLabel: true,
    type: undefined
  }));
};

exports.TextareaField = TextareaField;

var HiddenField = function HiddenField(_ref8) {
  var name = _ref8.name;
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref9) {
    var field = _ref9.field;
    return __jsx("input", (0, _extends2["default"])({
      type: "text",
      hidden: true,
      readOnly: true
    }, field));
  });
};

exports.HiddenField = HiddenField;

var CurrencyInputField = function CurrencyInputField(_ref10) {
  var name = _ref10.name,
      _ref10$type = _ref10.type,
      type = _ref10$type === void 0 ? 'text' : _ref10$type,
      placeholder = _ref10.placeholder,
      label = _ref10.label,
      description = _ref10.description,
      autoComplete = _ref10.autoComplete,
      autoFocus = _ref10.autoFocus,
      currency = _ref10.currency,
      size = _ref10.size,
      preventJump = _ref10.preventJump,
      displayLabel = _ref10.displayLabel,
      dataTestid = _ref10['data-testid'],
      props = (0, _objectWithoutProperties2["default"])(_ref10, ["name", "type", "placeholder", "label", "description", "autoComplete", "autoFocus", "currency", "size", "preventJump", "displayLabel", "data-testid"]);
  return (// The "children" approach was chosen because it returns
    // the "meta" prop which contains "error" and "touched" relative to the current field
    // instead of having to fetch from "errors" as provided if using "component"
    __jsx(_formik.Field, {
      name: name
    }, function (_ref11) {
      var _ref11$field = _ref11.field,
          value = _ref11$field.value,
          field = (0, _objectWithoutProperties2["default"])(_ref11$field, ["value"]),
          _ref11$meta = _ref11.meta,
          error = _ref11$meta.error,
          touched = _ref11$meta.touched;
      return __jsx(FieldWrapper, {
        name: name,
        label: label,
        description: description,
        displayLabel: displayLabel || (value === null || value === void 0 ? void 0 : value.toString().length),
        error: error,
        touched: touched,
        preventJump: preventJump
      }, __jsx(_CurrencyInput["default"], {
        currency: currency
      }, __jsx(_Input.Input, (0, _extends2["default"])({}, field, {
        value: value,
        type: type,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        "data-testid": dataTestid,
        placeholder: placeholder || label,
        className: error && touched ? 'error' : '',
        size: size
      }, props))));
    })
  );
};

exports.CurrencyInputField = CurrencyInputField;

var MaskedInputField = function MaskedInputField(_ref12) {
  var name = _ref12.name,
      label = _ref12.label,
      description = _ref12.description,
      autoComplete = _ref12.autoComplete,
      autoFocus = _ref12.autoFocus,
      mask = _ref12.mask,
      maskPlaceholder = _ref12.maskPlaceholder,
      allowReset = _ref12.allowReset,
      size = _ref12.size,
      preventJump = _ref12.preventJump,
      displayLabel = _ref12.displayLabel,
      dataTestid = _ref12['data-testid'],
      props = (0, _objectWithoutProperties2["default"])(_ref12, ["name", "label", "description", "autoComplete", "autoFocus", "mask", "maskPlaceholder", "allowReset", "size", "preventJump", "displayLabel", "data-testid"]);

  var _useState = (0, _react.useState)(false),
      hasFocus = _useState[0],
      setFocus = _useState[1];

  var inputRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (hasFocus && inputRef.current.value === maskPlaceholder) {
      inputRef.current.setSelectionRange(0, 0);
    }
  }, [hasFocus, maskPlaceholder]);
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref13) {
    var _ref13$field = _ref13.field,
        value = _ref13$field.value,
        onChange = _ref13$field.onChange,
        onBlur = _ref13$field.onBlur,
        field = (0, _objectWithoutProperties2["default"])(_ref13$field, ["value", "onChange", "onBlur"]),
        setFieldValue = _ref13.form.setFieldValue,
        _ref13$meta = _ref13.meta,
        error = _ref13$meta.error,
        touched = _ref13$meta.touched;

    function handleBlur() {
      setFocus(false);
      onBlur.apply(void 0, arguments);
    }

    function handleChange(event) {
      if (allowReset) {
        var inputValue = event.target.value;
        var valueWithoutPlaceholder = inputValue.replace(maskPlaceholder, '');
        setFieldValue(name, valueWithoutPlaceholder || '');
      } else {
        onChange(event);
      }
    }

    var shouldDisplayLabel = displayLabel || (value === null || value === void 0 ? void 0 : value.toString().length) || hasFocus;
    return __jsx(FieldWrapper, {
      name: name,
      label: label,
      description: description,
      displayLabel: shouldDisplayLabel,
      error: error,
      touched: touched,
      preventJump: preventJump
    }, __jsx(_Input.MaskedInput, (0, _extends2["default"])({}, field, {
      value: value,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      "data-testid": dataTestid,
      mask: hasFocus || value || displayLabel ? mask : label,
      maskPlaceholder: hasFocus || value || displayLabel ? maskPlaceholder : label,
      alwaysShowMask: true,
      onFocus: function onFocus() {
        return setFocus(true);
      },
      onChange: handleChange,
      onBlur: handleBlur,
      className: error && touched ? 'error' : '',
      size: size,
      ref: inputRef
    }, props)));
  });
};
/**
 * @callback transformValue
 * Allows modifying the field value before storing and is also used to set the default value
 * @param {Object} selectedOption - The selected option object
 * @param {string} selectedOption.label - The option label displayed on the list
 * @param {string} selectedOption.value - The value of the selected option
 */

/**
 * SelectField
 *
 * Formik input field abstraction, containing label, description and field error
 *
 * @param {Object} props - Component props
 * @param {String} props.name - Form field name
 * @param {String} props.label - Field label
 * @param {String} props.description - Field description
 * @param {Object[]} props.options - Field options
 * @param {String} props.options[].label - The option label to be displayed on the list
 * @param {String} props.options[].value - The option value
 * @param {transformValue} props.transformValue - Transform value callback
 * @param {Boolean} props.normalizeComparison - Transforms value to string to enable complex object comparison such as Date
 * @param {String} props.maxHeight - Size max height of the options list when open
 * @param {Boolean} props.isControlled - Defined if input is controlled. Especially useful when filling options list after component is rendered
 */


exports.MaskedInputField = MaskedInputField;
var SelectField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref14, ref) {
  var name = _ref14.name,
      label = _ref14.label,
      description = _ref14.description,
      isMulti = _ref14.isMulti,
      _ref14$options = _ref14.options,
      options = _ref14$options === void 0 ? [] : _ref14$options,
      transformValue = _ref14.transformValue,
      _ref14$normalizeCompa = _ref14.normalizeComparison,
      normalizeComparison = _ref14$normalizeCompa === void 0 ? true : _ref14$normalizeCompa,
      maxHeight = _ref14.maxHeight,
      preventJump = _ref14.preventJump,
      onChange = _ref14.onChange,
      withSearchIcon = _ref14.withSearchIcon,
      _ref14$isControlled = _ref14.isControlled,
      isControlled = _ref14$isControlled === void 0 ? false : _ref14$isControlled,
      isClearable = _ref14.isClearable,
      _ref14$clearValue = _ref14.clearValue,
      clearValue = _ref14$clearValue === void 0 ? function (value) {
    return value;
  } : _ref14$clearValue,
      dataTestid = _ref14['data-testid'],
      displayLabel = _ref14.displayLabel,
      props = (0, _objectWithoutProperties2["default"])(_ref14, ["name", "label", "description", "isMulti", "options", "transformValue", "normalizeComparison", "maxHeight", "preventJump", "onChange", "withSearchIcon", "isControlled", "isClearable", "clearValue", "data-testid", "displayLabel"]);
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref15) {
    var _ref15$field = _ref15.field,
        value = _ref15$field.value,
        field = (0, _objectWithoutProperties2["default"])(_ref15$field, ["value"]),
        setFieldValue = _ref15.form.setFieldValue,
        _ref15$meta = _ref15.meta,
        error = _ref15$meta.error,
        touched = _ref15$meta.touched;

    // Allow transforming field option before setting
    function handleChange(selectedOption, meta) {
      var action = meta.action;

      switch (action) {
        case 'clear':
          setFieldValue(name, clearValue(selectedOption));
          break;

        default:
          setFieldValue(name, transformValue ? transformValue(selectedOption) : selectedOption);
      }

      if (onChange) {
        var previousValue = value;
        onChange(selectedOption, meta, previousValue);
      }
    }
    /**
     * Find default value in options list
     * There are different type of received values, as a list of objects,
     * list of strings where we need to find the full option object.
     */


    function getDefaultValue() {
      if (isMulti && Array.isArray(value)) {
        return value.map(function (eachValue) {
          if (typeof eachValue === 'object') return eachValue;
          return options.find(function (option) {
            return option.value === eachValue;
          });
        });
      }

      return transformValue ? options === null || options === void 0 ? void 0 : options.find(function (option) {
        var transformedValue = transformValue(option);

        if (normalizeComparison) {
          return (transformedValue || '').toString() === (value || '').toString();
        }

        return transformedValue === value;
      }) : value;
    }

    var defaultValue = getDefaultValue(); // Defines if input is controlled or not
    // Useful and relevant when displaying default value and filling options list after component is rendered
    // Without isControlled, the default value is set and is not displayed after the options list is filled
    // This could cause unintended side effects when providing an object as the default value, so that's why it exists as a new prop.

    var valueProps = isControlled ? {
      // undefined value doesn't clear input label
      value: typeof defaultValue === 'undefined' ? '' : defaultValue
    } : {
      defaultValue: defaultValue
    };
    return __jsx(FieldWrapper, {
      name: name,
      label: label,
      description: description,
      displayLabel: displayLabel || (value === null || value === void 0 ? void 0 : value.toString().length),
      error: error,
      touched: touched,
      preventJump: preventJump
    }, __jsx(_styledComponents.ThemeConsumer, null, function (theme) {
      return __jsx(_reactSelect["default"], (0, _extends2["default"])({}, field, {
        id: "".concat(name, "-selector"),
        inputId: "".concat(name, "-selector-input"),
        instanceId: "".concat(name, "-selector-instance"),
        placeholder: label,
        onChange: handleChange,
        options: options,
        isMulti: isMulti,
        styles: (0, _Select.selectStyle)({
          theme: _objectSpread(_objectSpread({}, theme), {}, {
            maxHeight: maxHeight,
            isMulti: isMulti,
            withSearchIcon: withSearchIcon
          })
        })
      }, valueProps, {
        isClearable: isClearable,
        clearValue: clearValue,
        ref: ref
      }, props));
    }));
  });
});
exports.SelectField = SelectField;

var CompensationCurrencySelector = function CompensationCurrencySelector(_ref16) {
  var value = _ref16.value,
      currencies = _ref16.currencies,
      onChange = _ref16.onChange,
      dataTestid = _ref16['data-testid'];

  var _useState2 = (0, _react.useState)(value || currencies[0]),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var remainingValues = currencies.filter(function (currency) {
    return currency.slug !== currentValue.slug;
  });
  var canChooseCurrency = remainingValues.length > 0;

  function closePanel() {
    setIsOpen(false);
  }

  function togglePanel() {
    return setIsOpen(!isOpen);
  }

  function handleValueClick(selectedValue) {
    setCurrentValue(selectedValue);
    onChange(selectedValue);
    closePanel();
  }

  var currencyCode = currentValue.code;
  return __jsx(_CurrencySelector.CurrencySelector, {
    "data-testid": dataTestid
  }, canChooseCurrency ? __jsx(_CurrencySelector.CurrencySelectorButton, {
    type: "button",
    onClick: togglePanel
  }, __jsx(_Compensation.CompensationCountryFlag, {
    src: (0, _helpers.getCurrencyFlagSrc)(currencyCode),
    alt: "".concat(currencyCode, " country flag")
  }), currentValue.code, __jsx(_CurrencySelector.CurrencySelectorToggle, {
    isOpen: isOpen
  }, __jsx(_currencySelectorChevron["default"], null))) : __jsx(_CurrencySelector.CurrencySelectorButton, {
    as: "span"
  }, __jsx(_Compensation.CompensationCountryFlag, {
    src: (0, _helpers.getCurrencyFlagSrc)(currencyCode),
    alt: "".concat(currencyCode, " country flag")
  }), currentValue.code), canChooseCurrency && isOpen && __jsx(_CurrencySelector.CurrencySelectorOptions, null, remainingValues.map(function (currency) {
    var code = currency.code;
    return __jsx(_CurrencySelector.CurrencySelectorButton, {
      key: code,
      type: "button",
      onClick: function onClick() {
        return handleValueClick(currency);
      }
    }, __jsx(_Compensation.CompensationCountryFlag, {
      src: (0, _helpers.getCurrencyFlagSrc)(code),
      alt: "".concat(code, " country flag")
    }), ' ', code);
  })));
};

exports.CompensationCurrencySelector = CompensationCurrencySelector;
CompensationCurrencySelector.defaultProps = {
  currencies: []
};

var CompensationField = function CompensationField(_ref17) {
  var name = _ref17.name,
      type = _ref17.type,
      label = _ref17.label,
      description = _ref17.description,
      placeholder = _ref17.placeholder,
      autoComplete = _ref17.autoComplete,
      autoFocus = _ref17.autoFocus,
      size = _ref17.size,
      preventJump = _ref17.preventJump,
      dataTestid = _ref17['data-testid'],
      children = _ref17.children,
      props = (0, _objectWithoutProperties2["default"])(_ref17, ["name", "type", "label", "description", "placeholder", "autoComplete", "autoFocus", "size", "preventJump", "data-testid", "children"]);
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref18) {
    var _ref18$field = _ref18.field,
        value = _ref18$field.value,
        field = (0, _objectWithoutProperties2["default"])(_ref18$field, ["value"]),
        _ref18$meta = _ref18.meta,
        error = _ref18$meta.error,
        touched = _ref18$meta.touched;
    var displayErrorComponent = !description || error && touched;
    return __jsx(_Input.InputLabel, null, __jsx(_Input.CompensationFieldHeader, null, __jsx(_Input.CompensationTopLabel, null, label), displayErrorComponent ? __jsx(_Form.FormFieldError, {
      preventJump: preventJump,
      name: name
    }) : __jsx(_Input.LabelText, null, description)), __jsx(_Compensation.CompensationInput, null, __jsx(_Input.Input, (0, _extends2["default"])({}, field, {
      value: value,
      type: "text",
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      "data-testid": dataTestid,
      placeholder: placeholder,
      className: error && touched ? 'error' : '',
      size: size
    }, props)), children));
  });
};
/**
 * SelectField
 *
 * Formik input field abstraction, containing label, description and field error
 *
 * @param {Object} props - Component props
 * @param {String} props.name - Form field name
 * @param {String} props.label - Field label
 * @param {String} props.description - Field description
 * @param {Object[]} props.options - Field options
 * @param {String} props.options[].label - The option label to be displayed on the list
 * @param {String} props.options[].value - The option value
 * @param {transformValue} props.transformValue - Transform value callback
 * @param {Boolean} props.normalizeComparison - Transforms value to string to enable complex object comparison such as Date
 * @param {String} props.maxHeight - Size max height of the options list when open
 */


exports.CompensationField = CompensationField;

var CreatableSelectField = function CreatableSelectField(_ref19) {
  var name = _ref19.name,
      label = _ref19.label,
      description = _ref19.description,
      isMulti = _ref19.isMulti,
      options = _ref19.options,
      transformValue = _ref19.transformValue,
      _ref19$normalizeCompa = _ref19.normalizeComparison,
      normalizeComparison = _ref19$normalizeCompa === void 0 ? true : _ref19$normalizeCompa,
      maxHeight = _ref19.maxHeight,
      preventJump = _ref19.preventJump,
      onChange = _ref19.onChange,
      onCreate = _ref19.onCreate,
      createService = _ref19.createService,
      isLoading = _ref19.isLoading,
      isClearable = _ref19.isClearable,
      _ref19$clearValue = _ref19.clearValue,
      clearValue = _ref19$clearValue === void 0 ? function (value) {
    return value;
  } : _ref19$clearValue,
      dataTestid = _ref19['data-testid'],
      props = (0, _objectWithoutProperties2["default"])(_ref19, ["name", "label", "description", "isMulti", "options", "transformValue", "normalizeComparison", "maxHeight", "preventJump", "onChange", "onCreate", "createService", "isLoading", "isClearable", "clearValue", "data-testid"]);
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref20) {
    var _ref20$field = _ref20.field,
        value = _ref20$field.value,
        field = (0, _objectWithoutProperties2["default"])(_ref20$field, ["value"]),
        setFieldValue = _ref20.form.setFieldValue,
        _ref20$meta = _ref20.meta,
        error = _ref20$meta.error,
        touched = _ref20$meta.touched;

    // Allow transforming field option before setting
    function handleChange(selectedOption, meta) {
      var action = meta.action;

      switch (action) {
        case 'clear':
          setFieldValue(name, clearValue(selectedOption));
          break;

        default:
          setFieldValue(name, transformValue ? transformValue(selectedOption) : selectedOption);
      }

      if (onChange) {
        var previousValue = value;
        onChange(selectedOption, meta, previousValue);
      }
    }

    function handleOnCreate(_x) {
      return _handleOnCreate.apply(this, arguments);
    } // Find default value in options list


    function _handleOnCreate() {
      _handleOnCreate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(newValue) {
        var _yield$createService, data, newValueOption;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return createService(newValue);

              case 2:
                _yield$createService = _context.sent;
                data = _yield$createService.data.data;
                onCreate({
                  slug: data.slug,
                  name: newValue
                });
                newValueOption = {
                  value: data.slug,
                  label: newValue
                };
                setFieldValue(name, transformValue ? transformValue(newValueOption) : newValueOption);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _handleOnCreate.apply(this, arguments);
    }

    var defaultValue = transformValue ? options.find(function (option) {
      var transformedValue = transformValue(option);

      if (normalizeComparison) {
        return (transformedValue || '').toString() === (value || '').toString();
      }

      return transformedValue === value;
    }) : value;
    return __jsx(FieldWrapper, {
      name: name,
      label: label,
      description: description,
      displayLabel: value === null || value === void 0 ? void 0 : value.toString().length,
      error: error,
      touched: touched,
      preventJump: preventJump
    }, __jsx(_styledComponents.ThemeConsumer, null, function (theme) {
      return __jsx(_creatable["default"], (0, _extends2["default"])({}, field, {
        id: "".concat(name, "-selector"),
        inputId: "".concat(name, "-selector-input"),
        instanceId: "".concat(name, "-selector-instance"),
        placeholder: label,
        onChange: handleChange,
        onCreateOption: handleOnCreate,
        options: options,
        value: defaultValue,
        isMulti: isMulti,
        styles: (0, _Select.selectStyle)({
          theme: _objectSpread(_objectSpread({}, theme), {}, {
            maxHeight: maxHeight,
            isMulti: isMulti
          })
        }),
        isClearable: isClearable,
        clearValue: clearValue
      }, props, {
        isDisabled: isLoading,
        isLoading: isLoading
      }));
    }));
  });
};

exports.CreatableSelectField = CreatableSelectField;

var SearchContainer = _styledComponents["default"].div.withConfig({
  displayName: "Form__SearchContainer",
  componentId: "sc-1my8gp1-2"
})(["input{font-weight:normal;font-size:", ";line-height:1.2;border-radius:20px;background:url('/images/icons/search.svg') center no-repeat transparent;background-size:16px;outline:0;will-change:width;", " padding:12px 16px 12px 44px;background-position:12px center;cursor:auto;", " &::-webkit-input-placeholder,&::placeholder{color:var(--colors-bayoux);opacity:1;}}"], (0, _polished.rem)('14px'), (0, _motion.sharedTransition)('background, width'), function (_ref21) {
  var $variant = _ref21.$variant;

  switch ($variant) {
    case 'flat':
      return (0, _styledComponents.css)(["border:none;&:hover,&:focus{background-color:var(--colors-catskillWhite);}"]);

    case 'filters':
      return (0, _styledComponents.css)(["background:url(/images/icons/gray-search-icon.svg) no-repeat transparent;background-position:10px;border:1px solid var(--colors-geyser);background-size:14px;border-radius:8px;padding:9px 16px 9px 35px;"]);

    default:
      return (0, _styledComponents.css)(["background-color:var(--colors-catskillWhite);border:1px solid rgba(47,128,237,0.08);"]);
  }
});
/**
 * SearchField
 *
 * Formik input field abstraction, containing label, description and field error
 *
 * @param {Object} props - Component props
 * @param {String} props.name - Form field name
 * @param {String} props.label - Field label
 * @param {String} props.description - Field description
 * @param {Boolean} props.preventJump - Add an empty error message to avoid content shift
 * @param {String} props.placeholder - Field placeholder
 * @param {String} props.variant - Style variant
 */


var SearchField = function SearchField(_ref22) {
  var name = _ref22.name,
      label = _ref22.label,
      description = _ref22.description,
      preventJump = _ref22.preventJump,
      placeholder = _ref22.placeholder,
      variant = _ref22.variant;
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref23) {
    var _ref23$field = _ref23.field,
        value = _ref23$field.value,
        field = (0, _objectWithoutProperties2["default"])(_ref23$field, ["value"]),
        _ref23$meta = _ref23.meta,
        error = _ref23$meta.error,
        touched = _ref23$meta.touched;
    return __jsx(FieldWrapper, {
      name: name,
      label: label,
      description: description,
      displayLabel: value === null || value === void 0 ? void 0 : value.toString().length,
      error: error,
      touched: touched,
      preventJump: preventJump
    }, __jsx(SearchContainer, {
      $variant: variant
    }, __jsx(_Input.Input, (0, _extends2["default"])({}, field, {
      type: "search",
      name: name,
      "data-testid": "search-field-input",
      placeholder: placeholder,
      value: value
    }))));
  });
};

exports.SearchField = SearchField;